import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function GeneralSettingsTab() {
  const [value, setValue] = useState("");
  useEffect(() => {
    api.get("/settings/general").then(({ data }) => setValue(String(data.max_clienti_per_org))).catch(() => {});
  }, []);

  async function save() {
    try {
      const { data } = await api.put("/settings/general", { max_clienti_per_org: Number(value) });
      setValue(String(data.max_clienti_per_org));
      toast.success("Impostazioni salvate");
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  }

  return (
    <Card className="rounded-2xl border-slate-100 shadow-soft p-6 mt-4 max-w-xl" data-testid="general-settings-card">
      <Label className="text-sm font-semibold text-slate-800">Limite utenti cliente per azienda (valore generale)</Label>
      <p className="text-xs text-slate-500 mt-1 mb-3">Si applica a tutte le aziende, salvo eccezioni impostate nella scheda azienda.</p>
      <div className="flex gap-2">
        <Input type="number" min={1} max={50} value={value} onChange={(e) => setValue(e.target.value)} className="h-10 w-32" data-testid="general-max-users-input" />
        <Button onClick={save} data-testid="general-settings-save" className="bg-viva-500 hover:bg-viva-600 text-white">Salva</Button>
      </div>
    </Card>
  );
}
